import httpClient from "../utils/httpClient";
import userApi from "../apis/userApi";

export default {
    namespaced: true,
    state: {
        user: null,
        isLoggingIn: false,
    },
    getters: {

        isLoggedIn(state)
        {
            return state.user !== null && state.user.api_token !== null;
        }

    },
    mutations: {
        setIsLoggingIn(state, loggingIn)
        {
            state.isLoggingIn = loggingIn;
        },
        setUser(state, user)
        {
            state.user = user;
            httpClient.updateApiToken(user);
            localStorage.user = JSON.stringify(user);
        },


    },
    actions: {

        initializeStore({ commit, state })
        {
            if(localStorage.user !== null && localStorage.user !== undefined)
            {
                // set user from local storage
                state.user = JSON.parse(localStorage.user);
                httpClient.updateApiToken(state.user);

                // test api key
                return userApi.accountInfo().then(user => {
                    commit('setUser', user);
                }).catch(error => {
                    commit('setUser', null);
                });
            }
        },

        login({ commit }, credentials)
        {
            commit('setIsLoggingIn', true);
            return userApi.login(credentials.name, credentials.password).then(user => {
                commit('setUser', user);
                return true;
            }).catch(error => {
                commit('setUser', null);
                return false;
            }).finally(() => {
                commit('setIsLoggingIn', false);
            });
        },
        logout({ commit })
        {
            return userApi.logout().finally(() => {
                commit('setUser', null);
            });
        }
    }
}
